<template>
  <div class="picker-apply-submit">
    <div class="submit m-t20">
      <div class="top bg-gray flex-h-e-ac c-3 f-14 text-right f-b">
        <span class="m-r25">
          <span>预提</span>
          <span class="c-red f-20">{{ chooseData.totalNum || 0 }}</span>
          <span>件</span>
        </span>
        <span class="m-r20">
          <span class="c-red f-20">
            {{ chooseData.totalWeight | formatWeightWithUnitFix('', true) }}
          </span>
          <span>吨</span>
        </span>
      </div>
      <div class="flex-h-sb m-t20">
        <ul class="flex-h">
          <li class="p-t3" style="width: 15px;"><el-checkbox v-model="checked"></el-checkbox></li>
          <li class="p-l10">
            <div class="c-3 f-13 lh-20">
              提交提货函则表示您同意
              <a type="primary" :href="`${V2_ROOT}/#/tradingRules`" target="__blank">
                <span class="c-red f-13">《找钢网平台交易规则》</span>
              </a>
            </div>
          </li>
        </ul>
        <!--  -->
        <zg-button
          style="width: 150px; height: 50px; line-height: 30px; font-size: 18px; color: #FFF"
          :disable="canSubmit || !checked"
          :type="canSubmit || !checked ? 'disable' : 'main'"
          label="提交提货函"
          @click="submitDialog = true"
        >
        </zg-button>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="submitDialog" width="400px">
      <span>确认提交提货申请?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { V2_ROOT } from '@/common/constants/'
import ZgButton from '@/components/zg-button'

export default {
  name: 'PickerApplySubmit',
  components: { ZgButton },
  props: {
    canSubmit: {
      type: Boolean,
      default: false
    },
    chooseData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      V2_ROOT,
      checked: true,
      submitDialog: false
    }
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    submit() {
      this.$emit('submitApply')
      this.submitDialog = false
    }
  }
}
</script>

<style lang="less" scoped>
.picker-apply-submit {
  .submit {
    .top {
      height: 55px;
      border-top: 1px solid #cccccc;
    }
    .left {
      flex: 1;
      min-height: 127px;
    }
    .right {
      height: 100%;
    }
  }
}
</style>
